function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import axiosStatic from 'axios';
import { getCurrentApiHost, API_NAMESPACE, API_VERSION } from 'config/environment';
import { logger } from 'services';
import { axios } from './axios';
class HttpClient {
    /**
   * this base url is used to generate download url
   * for project files.
   * these download urls will be set as href for anchor tags.
   */ // eslint-disable-next-line class-methods-use-this -- getter returns dynamic host, no instance state
    get BASEURL() {
        return `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}`;
    }
    constructor(){
        _define_property(this, "_api", void 0);
        _define_property(this, "api", ()=>this._api);
        _define_property(this, "get", (url, config)=>{
            return this.api().get(url, config).then((x)=>x.data);
        });
        _define_property(this, "getResponse", (url, config)=>{
            return this.api().get(url, config).then((x)=>x);
        });
        _define_property(this, "post", (url, payload, config)=>this.api().post(url, payload, config).then((x)=>x.data));
        _define_property(this, "put", (url, payload, config)=>this.api().put(url, payload, config).then((x)=>x.data));
        _define_property(this, "patch", (url, payload, config)=>this.api().patch(url, payload, config).then((x)=>x.data));
        _define_property(this, "delete", (url, config)=>this.api().delete(url, config).then((x)=>x.data));
        _define_property(this, "stream", async (url, payload, config, method = 'GET')=>{
            try {
                var _ref;
                // Validate parameters
                if (method === 'POST' && !payload) {
                    throw new Error('Payload is required for POST requests');
                }
                const headers = {};
                const axiosHeaders = this._api.defaults.headers;
                if (axiosHeaders) {
                    Object.entries(axiosHeaders).forEach(([key, value])=>{
                        if (typeof value === 'string') {
                            headers[key] = value;
                        }
                    });
                }
                if (config === null || config === void 0 ? void 0 : config.headers) {
                    Object.entries(config.headers).forEach(([key, value])=>{
                        if (typeof value === 'string') {
                            headers[key] = value;
                        }
                    });
                }
                headers['initiator-source'] = 'UI';
                if (method === 'POST' && payload && !headers['Content-Type']) {
                    headers['Content-Type'] = 'application/json';
                }
                const responseForReturn = await fetch(((_ref = config === null || config === void 0 ? void 0 : config.baseURL) !== null && _ref !== void 0 ? _ref : this.BASEURL) + url, {
                    method,
                    headers,
                    body: payload ? JSON.stringify(payload) : undefined
                });
                if (!responseForReturn.ok) {
                    throw new Error(`HTTP ${responseForReturn.status}: ${responseForReturn.statusText}`);
                }
                const response = responseForReturn.clone();
                if (!response.body) {
                    throw new Error('No response body');
                }
                const reader = response.body.getReader();
                const processStream = async ()=>{
                    try {
                        const { done, value } = await reader.read();
                        if (done) {
                            if (config === null || config === void 0 ? void 0 : config.onStreamingComplete) {
                                config.onStreamingComplete();
                            }
                            return;
                        }
                        if (config === null || config === void 0 ? void 0 : config.onChunkReceived) {
                            config.onChunkReceived(new TextDecoder().decode(value));
                        }
                        await processStream();
                    } catch (streamError) {
                        var _config_onError;
                        logger.error('Error when processing stream', {
                            error: streamError
                        });
                        config === null || config === void 0 ? void 0 : (_config_onError = config.onError) === null || _config_onError === void 0 ? void 0 : _config_onError.call(config, streamError);
                    }
                };
                processStream();
                return responseForReturn;
            } catch (e) {
                var _config_onError;
                logger.error('Error when fetching with streaming', {
                    error: e
                });
                config === null || config === void 0 ? void 0 : (_config_onError = config.onError) === null || _config_onError === void 0 ? void 0 : _config_onError.call(config, e);
                throw e;
            }
        });
        this._api = axiosStatic.create({
            baseURL: this.BASEURL
        });
        axios().subscribe((client)=>{
            this._api = client;
        });
    }
}
export { HttpClient };
